const prepareRentalWidgetQueryParams = (data) => {
  const queryParams = {};
  Object.entries(data.widget_options).forEach(([key, value]) => {
    if (value != null) queryParams[`reservation[${key}]`] = value;
  });
  return queryParams;
};

export default prepareRentalWidgetQueryParams;
